import { useEffect, useMemo, useState } from 'react'
import { useClinicianSchedulingControllerGetCalendars } from '~/clinician-api'

interface CalendarSettings {
  enabledCalendars: Record<string, boolean>
  setEnabledCalendars: (calendars: Record<string, boolean>) => void
  enabledCalendarIds: string[]
}

export const useCalendarSettings = (): CalendarSettings => {
  const { data: calendars = [] } =
    useClinicianSchedulingControllerGetCalendars()

  const [enabledCalendars, setEnabledCalendars] = useState<
    Record<string, boolean>
  >({})

  useEffect(() => {
    if (calendars.length > 0) {
      const allCalendarsEnabled = calendars.reduce(
        (acc, calendar) => {
          acc[calendar.systemId] = true
          return acc
        },
        {} as Record<string, boolean>
      )

      setEnabledCalendars(allCalendarsEnabled)
    }
  }, [calendars])

  const enabledCalendarIds = useMemo(() => {
    return Object.entries(enabledCalendars)
      .filter(([_, isEnabled]) => isEnabled)
      .map(([systemId, _]) => systemId)
  }, [enabledCalendars])

  return {
    enabledCalendars,
    setEnabledCalendars,
    enabledCalendarIds
  }
}
